export default __webpack_public_path__ + "static/media/culture_EP1.d044e120.png";